<div *ngIf="answer">
  <h5>{{ question?.inspectorVisibility === 'never' ? 'Admin' : 'Inspector' }}'s answer</h5>
  <h6>
    <b *ngIf="!editing && !isPictureOrLocationOnly(question)">
      {{ answer.answer }}
      <button
        *ngIf="!readOnly"
        type="button"
        class="btn btn-sm"
        [ngClass]="{
          'btn-danger': question?.inspectorVisibility === 'never',
          'btn-light': question?.inspectorVisibility !== 'never'
        }"
        (click)="editing = true">
        <i class="fa fa-edit"></i>
      </button>
    </b>

    <form [formGroup]="form" (submit)="submit()" *ngIf="editing">
      <div class="form-group">
        <textarea
          *ngIf="question?.type !== 'pick-list'"
          class="form-control"
          formControlName="answer"
          [ngClass]="getValidationClass('answer')"></textarea>
        <select *ngIf="question?.type === 'pick-list'" class="form-control" formControlName="answer">
          <option *ngFor="let a of question?.options" [value]="a?.text">{{ a?.text }}</option>
        </select>
      </div>
      <button [disabled]="!form.valid" type="button" class="btn btn-sm btn-light" (click)="changeAnswer()">
        <i class="fa fa-save"></i>
      </button>
    </form>
  </h6>

  <p>Images:</p>

  <div *ngIf="!answer.pictures?.length" style="margin-bottom: 20px">No images attached</div>

  <div *ngIf="answer.pictures?.length" style="margin-bottom: 20px" (click)="showPictures()">
    <span
      style="display: inline-block; width: 100px; box-shadow: 0px 0px 7px #000; cursor: pointer; margin: 5px"
      class="{{ rotate(p?.exif?.Orientation) }}"
      *ngFor="let p of answer.pictures">
      <img-ajax [src]="p.Location"></img-ajax>
    </span>
  </div>
  <input type="file" (change)="setUploadFile($event.target.files)" />
  <button class="btn btn-primary" (click)="uploadFile()">Upload</button>
  <br />
  <br />

  <h6>Comments:</h6>

  <form (submit)="addComment(newComment.value); newComment.value = ''">
    <div class="form-group" style="position: relative">
      <input
        type="text"
        class="form-control"
        style="padding: 10px 30px 10px 10px"
        placeholder="Add new Comment"
        #newComment />
      <button type="submit" class="btn" style="position: absolute; top: 0; right: 0px; color: #2763cd">
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </form>

  <div
    style="
      background-color: #dee7f5;
      border-radius: 4px;
      color: #3465c4;
      padding: 15px;
      margin-bottom: 15px;
      display: flex;
      text-align: left;
    "
    *ngFor="let comment of answer.comments; index as i">
    <div>
      <i class="fa fa-comment"></i>
    </div>
    <div style="flex: 1; padding: 0 20px">
      <p style="font-weight: bold; margin: 0 0 10px">{{ comment.text }}</p>
      <p style="color: #444; margin: 0; font-size: 13px">{{ dateAsString(comment.date) }} / {{ comment.username }}</p>
    </div>
    <div>
      <i style="cursor: pointer" class="fa fa-trash" (click)="removeComment(i)"></i>
    </div>
  </div>

  <hr />
</div>
